import { render } from "./MdvNavbar.vue?vue&type=template&id=fd0f5218&scoped=true"
import script from "./MdvNavbar.vue?vue&type=script&lang=js"
export * from "./MdvNavbar.vue?vue&type=script&lang=js"

import "./MdvNavbar.vue?vue&type=style&index=0&id=fd0f5218&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sciam\\Desktop\\Workspaces\\local\\workspace_vue\\mdv-webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd0f5218"]])

export default __exports__